import { render, staticRenderFns } from "./ContratosModule.vue?vue&type=template&id=3f70b43c&scoped=true&"
import script from "./ContratosModule.vue?vue&type=script&lang=js&"
export * from "./ContratosModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f70b43c",
  null
  
)

export default component.exports